module.exports = __webpack_public_path__ + "img/call_operator_icon.ce4641ee.svg";